var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRectangleMazeDesktop = function SvgRectangleMazeDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1226,
    height: 2889,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#RectangleMazeDesktop_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-42 7h1240c11.05 0 20 8.954 20 20v386c0 11.046-8.95 20-20 20H98c-11.046 0-20 8.954-20 20v312c0 11.046 8.954 20 20 20h1100c11.05 0 20 8.954 20 20v348.5c0 11.05-8.95 20-20 20H98c-11.046 0-20 8.95-20 20V1581c0 11.05 8.954 20 20 20h1100c11.05 0 20 8.95 20 20v420c0 11.05-8.95 20-20 20H98c-11.046 0-20 8.95-20 20v348c0 11.05 8.954 20 20 20h1100c11.05 0 20 8.95 20 20v388.5c0 11.05-8.95 20-20 20H-42",
    stroke: "url(#RectangleMazeDesktop_svg__b)",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "RectangleMazeDesktop_svg__b",
    x1: 588,
    y1: 7,
    x2: 588,
    y2: 3176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F82BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07D170"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "RectangleMazeDesktop_svg__a",
    x: -50,
    y: 0,
    width: 1276,
    height: 2888.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2072_3207"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2072_3207",
    result: "shape"
  })))));
};

export default SvgRectangleMazeDesktop;